module.exports = __webpack_public_path__ + "img/step28_a_install_right_adapter.c3ce8128.png";